import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as types from "./mutation-types";

Vue.use(Vuex);

const mutations = {
    [types.SET_USER](state, { nombre, apellido, email, franquicia_id }) {
        state.user = {
            nombre: nombre,
            apellido: apellido,
            email: email,
            franquicia_id: franquicia_id,
        };
    },
    [types.CLEAR_IDEA](state) {
        state.idea = { idea: null, descripcion: null, pathway: [], axis: [], beneficio: null, criterio: [] };
    },
    [types.SET_IDEA](state, { idea, descripcion, pathway, axis, beneficio, criterio }) {
        state.idea = {
            idea: idea,
            descripcion: descripcion,
            pathway: pathway,
            axis: axis,
            beneficio: beneficio,
            criterio: criterio,
        };
    },

    [types.CLEAR_PROJECT](state) {
        state.project = {
            project: null,
            fecha_inicio: null,
            fecha_final: null,
            pathway: [],
            axis: [],
            axis_otros: null,
            beneficio: null,
            evidencias: [],
            criterios: [],
            criterio_otros: null,
            herramienta: null,
            herramientas: [],
            implementacion: null,
            implementacion_tiempo: null,
            implementacion_costo: null,
            implementacion_costo_mantenimiento: null,
            implementacion_comentarios: null,
        };
    },
    [types.SET_PROJECT](
        state,
        {
            project,
            fecha_inicio,
            fecha_final,
            pathway,
            axis,
            axis_otros,
            beneficio,
            evidencias,
            criterios,
            criterio_otros,
            herramienta,
            herramientas,
            implementacion,
            implementacion_tiempo,
            implementacion_costo,
            implementacion_costo_mantenimiento,
            implementacion_comentarios,
        }
    ) {
        state.project = {
            project: project,
            fecha_inicio: fecha_inicio,
            fecha_final: fecha_final,
            pathway: pathway,
            axis: axis,
            axis_otros: axis_otros,
            beneficio: beneficio,
            evidencias: evidencias,
            criterios: criterios,
            criterio_otros: criterio_otros,
            herramienta: herramienta,
            herramientas: herramientas,
            implementacion: implementacion,
            implementacion_tiempo: implementacion_tiempo,
            implementacion_costo: implementacion_costo,
            implementacion_costo_mantenimiento: implementacion_costo_mantenimiento,
            implementacion_comentarios: implementacion_comentarios,
        };
    },
};

const state = {
    user: {
        nombre: null,
        apellido: null,
        email: null,
        franquicia_id: null,
    },
    idea: {
        idea: null,
        descripcion: null,
        pathway: [],
        axis: [],
        beneficio: null,
        criterio: [],
    },
    project: {
        project: null,
        fecha_inicio: null,
        fecha_final: null,
        pathway: [],
        axis: [],
        axis_otros: null,
        beneficio: null,
        evidencias: [],
        criterios: [],
        criterio_otros: null,
        herramienta: null,
        herramientas: [],
        implementacion: null,
        implementacion_tiempo: null,
        implementacion_costo: null,
        implementacion_costo_mantenimiento: null,
        implementacion_comentarios: null,
    },
};

const getters = {
    getUser: (state) => state.user,
    getIdea: (state) => state.idea,
    getProject: (state) => state.project,
};

const actions = {
    clearIdea({ commit }) {
        commit(types.CLEAR_IDEA);
    },
    clearProject({ commit }) {
        commit(types.CLEAR_PROJECT);
    },
    setUser({ commit }, data) {
        commit(types.SET_USER, {
            nombre: data.nombre,
            apellido: data.apellido,
            email: data.email,
            franquicia_id: data.franquicia_id,
        });
    },
    setIdea({ commit }, data) {
        commit(types.SET_IDEA, {
            idea: data.idea,
            descripcion: data.descripcion,
            pathway: data.pathway,
            axis: data.axis,
            beneficio: data.beneficio,
            criterio: data.criterio,
        });
    },
    setProject({ commit }, data) {
        commit(types.SET_PROJECT, {
            project: data.project,
            fecha_inicio: data.fecha_inicio,
            fecha_final: data.fecha_final,
            pathway: data.pathway,
            axis: data.axis,
            axis_otros: data.axis_otros,
            beneficio: data.beneficio,
            evidencias: data.evidencias,
            criterios: data.criterios,
            criterio_otros: data.criterio_otros,
            herramientas: data.herramientas,
            herramienta: data.herramienta,
            implementacion: data.implementacion,
            implementacion_tiempo: data.implementacion_tiempo,
            implementacion_costo: data.implementacion_costo,
            implementacion_costo_mantenimiento: data.implementacion_costo_mantenimiento,
            implementacion_comentarios: data.implementacion_comentarios,
        });
    },
};

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    plugins: [createPersistedState()],
});
